export const UNREAD = 1
export const PENDING = 2
export const SOLVED = 3